export default {
	setDistributionAppData(state, entorno) {
		state.entorno = entorno;
	}
};
